import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-failed-page',
  templateUrl: './login-failed-page.component.html',
  styleUrls: ['./login-failed-page.component.scss']
})
export class LoginFailedPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
